import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Vehicles from "@/pages/Vehicles";
import PreQualify from "@/pages/PreQualify";
import Apply from "@/pages/Apply";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import Faq from "@/pages/Faq";
import Popia from "@/pages/Popia";
import AgreementSign from "@/pages/AgreementSign";
import StatementView from "@/pages/StatementView";
import Portal from "@/pages/Portal";
import RentalBooking from "@/pages/RentalBooking";
import TradeIn from "@/pages/TradeIn";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import PayDeposit from "@/pages/PayDeposit";
import ReceiptView from "@/pages/ReceiptView";
import CertificateView from "@/pages/CertificateView";
import Track from "@/pages/Track";
import Calculator from "@/pages/Calculator";
import ReferAFriend from "@/pages/ReferAFriend";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <div className="noise-overlay" aria-hidden="true" />
        <Navbar />
        <WhatsAppFloat />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/vehicles" element={<Vehicles />} />
            <Route path="/pre-qualify" element={<PreQualify />} />
            <Route path="/apply" element={<Apply />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/popia" element={<Popia />} />
            <Route path="/agreement/:token" element={<AgreementSign />} />
            <Route path="/statement/:token" element={<StatementView />} />
            <Route path="/portal" element={<Portal />} />
            <Route path="/rental" element={<RentalBooking />} />
            <Route path="/trade-in" element={<TradeIn />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/pay-deposit/:reference" element={<PayDeposit />} />
            <Route path="/receipt/:token" element={<ReceiptView />} />
            <Route path="/certificate/:token" element={<CertificateView />} />
            <Route path="/track" element={<Track />} />
            <Route path="/calculator" element={<Calculator />} />
            <Route path="/refer-a-friend" element={<ReferAFriend />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-center" richColors theme="dark" />
      </BrowserRouter>
    </div>
  );
}

export default App;
